import React from 'react'

import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import IconButton from '@mui/material/IconButton'

import { ArrowBack } from '@mxenabled/mx-icons'

import { H2 } from '@mxenabled/mxui'

interface DrawerHeaderProps {
  ariaLabelClose: string
  onClose: () => void
  shouldShowBorders: boolean
  shouldShowShadow?: boolean
  title: string
}

const DrawerHeader: React.FC<DrawerHeaderProps> = ({
  ariaLabelClose,
  onClose,
  shouldShowBorders,
  shouldShowShadow,
  title,
}) => {
  return (
    <Stack
      aria-labelledby={`${title?.replace(/\s+/g, '-').toLowerCase()}-header-title`}
      direction="row"
      sx={{
        alignItems: 'center',
        backgroundColor: 'background.paper',
        ...(shouldShowBorders && {
          borderBottom: 1,
          borderColor: 'divider',
        }),
        ...(shouldShowShadow && {
          boxShadow: '0px 2px 8px 0px #6A73811F',
        }),
        padding: '8px 8px 8px 8px',
      }}
    >
      <IconButton aria-label={ariaLabelClose} autoFocus={true} color="primary" onClick={onClose}>
        <ArrowBack color="primary" sx={{ fontSize: 22 }} />
      </IconButton>
      <Box
        sx={{
          flexGrow: 1,
          margin: 'auto',
          textAlign: 'center',
        }}
      >
        <H2
          bold={true}
          id={`${title?.replace(/\s+/g, '-').toLowerCase()}-header-title`}
          variant="body1"
        >
          {title}
        </H2>
      </Box>
      {/* placeholder for when we add a button here, this also ensures the title text is centered */}
      <Box width="44px" />
    </Stack>
  )
}

export default DrawerHeader
